export default __webpack_public_path__ + "static/media/avtoritet.b0b7136a.jpg";